import React from "react";
import { FaEnvelope } from "react-icons/fa";
import { TextInput, Textarea } from "../../atoms";
import FirmContactsField from "../FirmContactsField";

/**
 * Firma oluşturma — 2. adım: e-posta, telefon, muhataplar (#367), adres;
 * kurumsalsa vergi (#275).
 */
export default function FirmContactStep({ input, errors, onChange, onAddressChange }) {
  return (
    <div className="space-y-6">
      <div className="bg-gray-50 rounded-lg p-4">
        <h3 className="text-base font-SemiBold text-gray-800 mb-4 flex items-center gap-2">
          <FaEnvelope className="w-4 h-4 text-blue-600" />
          İletişim
        </h3>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <TextInput
            label="Email"
            placeholder="firma@example.com"
            value={input.email}
            onChange={(e) => onChange("email", e.target.value)}
            error={!!errors.email}
            errorMessage={errors.email}
            type="email"
          />
          <TextInput
            label="Telefon"
            placeholder="0555 123 45 67"
            value={input.tel}
            onChange={(e) => onChange("tel", e.target.value)}
            error={!!errors.tel}
            errorMessage={errors.tel}
            type="tel"
          />
          {/* Muhataplar — ad + telefon, isteğe bağlı, birden fazla (#367) */}
          <div className="md:col-span-2">
            <FirmContactsField
              value={input.contacts}
              onChange={(rows) => onChange("contacts", rows)}
              errors={errors.contacts}
            />
          </div>
        </div>
      </div>

      {/* Vergi bilgileri — bireyselde görünür ama pasif (#373) */}
      <div className={`bg-gray-50 rounded-lg p-4 ${input.isCorporate ? "" : "opacity-60"}`} aria-disabled={!input.isCorporate || undefined}>
        <h3 className="text-base font-SemiBold text-gray-800 mb-1">Vergi Bilgileri</h3>
        <p className="text-xs text-gray-500 mb-3">
          {input.isCorporate ? "Kurumsal firma için zorunlu." : "Bireysel firmada kullanılmaz — 1. adımda Kurumsal seçilince açılır."}
        </p>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          <TextInput
            label="Vergi Numarası"
            placeholder="Vergi numarası"
            value={input.isCorporate ? input.taxNumber : ""}
            onChange={(e) => onChange("taxNumber", e.target.value)}
            error={!!errors.taxNumber}
            errorMessage={errors.taxNumber}
            required={input.isCorporate}
            disabled={!input.isCorporate}
            className={input.isCorporate ? "" : "cursor-not-allowed bg-gray-100"}
          />
          <TextInput
            label="Vergi Dairesi"
            placeholder="Vergi dairesi"
            value={input.isCorporate ? input.taxOffice : ""}
            onChange={(e) => onChange("taxOffice", e.target.value)}
            error={!!errors.taxOffice}
            errorMessage={errors.taxOffice}
            required={input.isCorporate}
            disabled={!input.isCorporate}
            className={input.isCorporate ? "" : "cursor-not-allowed bg-gray-100"}
          />
          <TextInput
            label="Resmi ID"
            placeholder="Resmi ID"
            value={input.isCorporate ? input.officialNumber : ""}
            onChange={(e) => onChange("officialNumber", e.target.value)}
            error={!!errors.officialNumber}
            errorMessage={errors.officialNumber}
            required={input.isCorporate}
            disabled={!input.isCorporate}
            className={input.isCorporate ? "" : "cursor-not-allowed bg-gray-100"}
          />
        </div>
      </div>

      <div className="bg-gray-50 rounded-lg p-4">
        <h3 className="text-base font-SemiBold text-gray-800 mb-4">Adres Bilgileri</h3>
        <div className="space-y-4">
          <Textarea
            label="Adres"
            placeholder="Detaylı adres bilgisi"
            value={input.address.text}
            onChange={(e) => onAddressChange("text", e.target.value)}
            error={!!errors.addressText}
            errorMessage={errors.addressText}
            required
            rows={3}
          />
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <TextInput
              label="Şehir"
              placeholder="Şehir"
              value={input.address.city}
              onChange={(e) => onAddressChange("city", e.target.value)}
              error={!!errors.addressCity}
              errorMessage={errors.addressCity}
              required
            />
            <TextInput
              label="İlçe"
              placeholder="İlçe"
              value={input.address.town}
              onChange={(e) => onAddressChange("town", e.target.value)}
              error={!!errors.addressTown}
              errorMessage={errors.addressTown}
              required
            />
          </div>
        </div>
      </div>
    </div>
  );
}
